/*
*   Google Maps librairy - MG2 Media
*   @author Mathilde Paccoud & François Vandal
*   @version: 0.4
*   Last update: 28 mars 2016
*/

(function($, global, undefined) {
    
    'use strict';
    var currPage;
    var win = $(window);
    
    var counter = 0;
    var distance = 15;
    var maxResults = 25;
    var eleMaps;
    var mapsList = {};
    var currInfoOpen = '';
    var circle = [];
    
    var isCatererAdmin = false;
    var map;
    
    // var markerDefault = {
    //     imageName: 'map-marker.png'
    // };
    
    var defaults = {
        latitude: 45.50867,
        longitude: -73.553992,
        zoom: 16,
        scrollwheel: false,
        getLocalMarker: true,
        getAjaxMarkerList: false,
        ajaxMarkerListDistance: 15,
        ajaxMarkerListMaxResults: 25,
        ajaxReloadOnClick: true
    };
    
    var getUrlVars = function () {
        var vars = [], hash;
        if (window.location.href.indexOf('?') !== -1) {
            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for(var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                //vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
        } else {
            return [];
        }
    };
    
    var centerMapByCoor = function (map, myLatlng) {
        map.setCenter(myLatlng);
    };
    
    var getMarkers = function (mapClass, distance, maxResults, element){
        var currMap = mapsList[mapClass].theMap;
        var mapCenter = currMap.getCenter();
        var mapCenterLat = mapCenter.lat();
        var mapCenterLng = mapCenter.lng();
        var url = '/action/getOrganizations?lat='+mapCenterLat+'&lng='+mapCenterLng+'&distance='+distance+'&maxResults='+maxResults;
        
        
        ajax(url,function(data){         
            getJson(data, mapClass, element);
        },true);
//        $.ajax({
//            url:        url,
//            cache:      false,
//            contentType: false,
//            processData: false,
//            type:       'POST',
//            success: function(data) {
//                console.log('data : ' + data);
//                console.log('mapClass : ' + mapClass);
//                console.log('element : ' + element);
//            }
//        });
    }; 
    
    var getJson = function (response, mapClass, element){
        var obj = JSON.parse(response.trim());
        var lang = $('html').attr('lang');
        var markersArray = [];
        
        var tempTotal = 0;
        for(var i=0 ; i<obj.length ; i++){
            var exists = false;
            var id = obj[i].id;
            var lat = obj[i].lat;
            var lng = obj[i].lng;
            var name = decodeText(obj[i].name);
            var point = new google.maps.LatLng(lat,lng);
            for(var x = 0; x < markersArray.length; x++) {
                if ( markersArray[x][0].getPosition().equals( point ) && markersArray[x][1] == name) {
                    exists = true;
                }
            }
            var address = decodeText(obj[i].address);
            var city = decodeText(obj[i].city);
            var postalCode = decodeText(obj[i].postalCode);
            //var province = decodeText(obj[i].province);
            var markerName = decodeText(obj[i].field1);
            if(!exists && lat !== 0 && lat !== '' && lng !== 0 && lng !== ''){
                markerName = encodeText(markerName);
                addMarkerInner(lang,id, lat, lng, name, address, city, postalCode, markerName, mapClass, element, markersArray);
            }
        }
        
        mapsList[mapClass] = $.extend(mapsList[mapClass], {markers: markersArray});
        
        //setMapBound(mapClass);
    };
    
    var addMarkerInner = function (lang,id, lat, lng, name, address, city, postalCode, markerName, mapClass, element, markersArray) {
        var currMap = mapsList[mapClass].theMap;
        
        var markerOptions = {
            imageName: element.data('markerName'),
            btnValue: element.data('popupBtnValue'),
            btnUrlBeforeId: element.data('popupUrlBeforeId')
        };
        
        // var markerSettings = $.extend({}, markerDefault, markerOptions);
        
        var myLatlng = new google.maps.LatLng(lat,lng);
        
        // var iconPath = '/static/assets/img/' + markerSettings.imageName;
        
        var marker = new google.maps.Marker({
            position: myLatlng,
            title: name,
            // icon: iconPath
        });
        
        google.maps.event.addListener(marker, 'click', function() {
            var popupWindow = $('.users-caterers-detail-window', currPage);
            var popupItem = $('.users-caterers-detail-item[data-id='+id+']', popupWindow);
            
            var scale = Math.pow(2, currMap.getZoom());
            
            var offsetx = 160;
            var offsety = 0;
            
            var worldCoordinateCenter = currMap.getProjection().fromLatLngToPoint(myLatlng);
            var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0);
            
            var worldCoordinateNewCenter = new google.maps.Point(
                   worldCoordinateCenter.x - pixelOffset.x,
                   worldCoordinateCenter.y + pixelOffset.y
            );
            
            var newCenter = currMap.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
            
            popupWindow.addClass('open');
            $('.users-caterers-detail-item', popupWindow).removeClass('show');
            popupItem.addClass('show');
            
            currMap.panTo(newCenter);
        });
        markersArray.push([marker,name]);
        
        marker.setMap(currMap);
    };

    var clusterIt = function (map){
        var mc = new MarkerClusterer(map,markersArray);
    };
    
    var addSingleMarkers = function (obj, mapClass, myLatlng, icon) {
        var currMap = mapsList[mapClass].theMap;
        
        var markerOptions = {
            imageName: obj.data('markerName')
        };
        
        // var markerSettings = $.extend({}, markerDefault, markerOptions);
        
        if(icon === undefined){
            var marker = new google.maps.Marker({
                position: myLatlng,
                // title: 'obj.data('name')',
                // icon: '/static/assets/img/' + markerSettings.imageName
            });
        }
        else{    
            var marker = new google.maps.Marker({
                position: myLatlng,
                // title: obj.data('name'),
                // icon: icon
            });
        }
        
        marker.setMap(currMap);
        
        mapsList[mapClass] = $.extend(mapsList[mapClass], {markers: marker});
    };
    
    var createMaps = function () {
        eleMaps.each(function () {
            var t = $(this);
            var addedClass;
            
            if (t.attr('id') !== 0) {
                addedClass = t.attr('id');
            } else {
                addedClass = 'map-created-' + t.index();
                t.attr('id', addedClass);
            }
            
            var options = {
                latitude: t.data('latitude'),
                longitude: t.data('longitude'),
                zoom: t.data('zoom'),
                scrollwheel: t.data('scrollwheel'),
                getLocalMarker: t.data('getLocalMarker'),
                getPrefinedMarker: t.data('predefinedMarker'),
                getPrefinedMarkerScale: t.data('predefinedMarkerScale'),
                getAjaxMarkerList: t.data('getAjaxMarkerList'),
                ajaxMarkerListDistance: t.data('ajaxMarkerListDistance'),
                ajaxMarkerListMaxResults: t.data('ajaxMarkerListMaxResults'),
                ajaxReloadOnIdle: t.data('ajaxReloadOnIdle'),
                drawCircle: t.data('drawCircle'),             
                drawCircleFill: t.data('drawCircleFill'),             
                drawCircleStroke: t.data('drawCircleStroke')             
            };
            var settings = $.extend({}, defaults, options);
            
            var myLatlng = new google.maps.LatLng(settings.latitude,settings.longitude);
            var mapOptions = {
                zoom: settings.zoom,
                center: myLatlng,
                scrollwheel: settings.scrollwheel,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                styles:  [
                    {
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#dadada"
                      }]
                    },
                    {
                    "elementType": "geometry.stroke",
                    "stylers": [{
                        "color": "#cacaca"
                      }]
                    },
                    {
                    "featureType": "administrative",
                    "stylers": [{
                        "visibility": "off"
                      }]
                    },
                    {
                    "featureType": "poi",
                    "stylers": [{
                        "visibility": "off"
                      }]
                    },
                    {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#e5e5e5"
                      }]
                    },
                    {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [{
                        "visibility": "off"
                      }]
                    },
                    {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [{
                        "visibility": "off"
                      }]
                    },
                    {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#006b6d"
                      }]
                    },
                    {
                    "featureType": "transit",
                    "stylers": [{
                        "visibility": "off"
                      }]
                    },
                    {
                    "featureType": "water",
                    "stylers": [{
                        "visibility": "off"
                      }]
                    }
                ],
            };
            
            map = new google.maps.Map(t.get(0), mapOptions);
            
            mapsList[addedClass] = {
                theMap: map,
                settings: settings
            };
            
            //var styledMap = new google.maps.StyledMapType(styles,{name: "Styled Map"});
            
            //map.mapTypes.set('map_style', styledMap);
            //map.setMapTypeId('map_style');
            google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
                if (settings.getLocalMarker) {
                    addSingleMarkers(t, addedClass, myLatlng);
                }
                if (settings.getPrefinedMarker) {
                    var type = (settings.getPrefinedMarker === 'CIRCLE') ? 0 : 1;
                    var icon = {
                        path: type,
                        scale: settings.getPrefinedMarkerScale
                      };
                    addSingleMarkers(t, addedClass, myLatlng, icon);
                }
                if (settings.getAjaxMarkerList && !settings.getLocalMarker) {
                    if (settings.ajaxReloadOnIdle) {
                        google.maps.event.addListener(map, 'idle', function() {
                            getMarkers(addedClass,settings.ajaxMarkerListDistance,settings.ajaxMarkerListMaxResults, t);
                        });
                    } else {
                        getMarkers(addedClass,settings.ajaxMarkerListDistance,settings.ajaxMarkerListMaxResults, t);
                    }
                }
                if(settings.drawCircle){
                    var radius = parseFloat(settings.drawCircle);
                    drawCircle(radius, settings.drawCircleStroke, settings.drawCircleFill);
                }
            });
        });
    };
    var getLatLng = function(map) {
        var geo = new google.maps.Geocoder();
        var addr = map.attr("data-address");
        geo.geocode({'address':addr},function(results, status){
            if (status == google.maps.GeocoderStatus.OK) {
                map.attr("data-latitude" , results[0].geometry.location.lat());
                map.attr("data-longitude" , results[0].geometry.location.lng());
                createMaps();             
            } else {
                return false;
            }
        });
    };
    var setMapBound = function (addedClass) {
        var currMap = mapsList[addedClass].theMap;
        var markers = mapsList[addedClass].markers;
        var bounds = new google.maps.LatLngBounds();
        
        for (var i = 0; i < markers.length; i++) {
            bounds.extend(markers[i][0].getPosition());
        }
        
        currMap.fitBounds(bounds);
    };
    
    var setMapOnAll = function (map) {
        var currMap = mapsList[map];
        var currMarkers = currMap.markers;
        
        for (var i = 0; i < currMarkers.length; i++) {
            currMarkers[i][0].setMap(null);
        }
    };
    
    var clearMap = function (map) { 
        setMapOnAll(map);
        mapsList[map].markers = [];
        setMapBound(map);
    };
    
    var init = function (page) {
        currPage = $(page);
        
        eleMaps = $('.js-maps:not(.no-init-load)', currPage);
        
        createMaps();
    };
    
    var initSingleMap = function(map) {
        eleMaps = $(map);
        getLatLng(eleMaps);
    };
    
    var drawCircle = function(radius, stroke, fill) {
        if(radius !== ''){
            if(circle.length !== 0){
                $.each(circle,function(index, value){
                    circle[index].setMap(null);
                });
            }
            eleMaps.each(function(index) {
                var myLatlng = new google.maps.LatLng($(this).data("latitude"),$(this).data("longitude"));
                circle[index] = new google.maps.Circle({
                    strokeColor: stroke,
                    strokeOpacity: 1,
                    strokeWeight: 5,
                    fillColor: fill,
                    fillOpacity: 0.65,
                    map: map,
                    center: myLatlng,
                    radius: parseFloat(radius) //meters
                });
            });
        }
    };
    
    var gmaps = Fw.modules.export('gmaps', {
        init: init,
        initSingleMap: initSingleMap,
        drawCircle: drawCircle
    });
    
    
    var encodeText = function (name){
        name = name.replace(/\\xE0/g,'\xE0');
        name = name.replace(/\\xE2/g,'\xE2');
        name = name.replace(/\\xE3/g,'\xE3');
        name = name.replace(/\\xE4/g,'\xE4');
        name = name.replace(/\\xE5/g,'\xE5');
        name = name.replace(/\\xE9/g,'\xE9');
        name = name.replace(/\\xE8/g,'\xE8');
        name = name.replace(/\\xEA/g,'\xEA');
        name = name.replace(/\\xEB/g,'\xEB');
        name = name.replace(/\\xEE/g,'\xEE');
        name = name.replace(/\\xEF/g,'\xEF');
        name = name.replace(/\\xF1/g,'\xF1');
        name = name.replace(/\\xF2/g,'\xF2');
        name = name.replace(/\\xF3/g,'\xF3');
        name = name.replace(/\\xF4/g,'\xF4');
        name = name.replace(/\\xF6/g,'\xF6');
        name = name.replace(/\\xF9/g,'\xF9');
        name = name.replace(/\\xFB/g,'\xFB');
        name = name.replace(/\\xE7/g,'\xE7');
        name = name.replace(/\\xC0/g,'\xC0');
        name = name.replace(/\\xC7/g,'\xC7');
        name = name.replace(/\\xC8/g,'\xC8');
        name = name.replace(/\\xC9/g,'\xC9');
        name = name.replace(/\\xCA/g,'\xCA');
        name = name.replace(/\\xCE/g,'\xCE');
        name = name.replace(/\\xCF/g,'\xCF');
        name = name.replace(/\\xD1/g,'\xD1');
        name = name.replace(/\\xD4/g,'\xD4');  
        return name;
    };
    
    var decodeText = function (name){
        name = name.replace(/\\xE0/g,'à');
        name = name.replace(/\\xE8/g,'è');
        name = name.replace(/\\xE9/g,'é');
        name = name.replace(/\\xC0/g,'À');
        name = name.replace(/\\xC8/g,'È');
        name = name.replace(/\\xC9/g,'É');
        return name;
    };
    
    var styles = [
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "hue": "#f2ff00"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "hue": "#dd0000"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [
                {
                    "hue": "#ffff00"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "hue": "#007fff"
                }
            ]
        }
    ];
    
    
})(jQuery);
